import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

export function initSwiperSlider() {
    const logoSlider = new Swiper('.logo-slider', {
        modules: [Autoplay],

        // Grundeinstellungen
        slidesPerView: 2,
        spaceBetween: 16,
        loop: true,
        speed: 6000,

        // Autoplay
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },

        // Responsive Breakpoints
        breakpoints: {
            576: {
                slidesPerView: 3,
                spaceBetween: 16
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1024: {
                slidesPerView: 6,
                spaceBetween: 24
            },
            1280: {
                slidesPerView:7,
                spaceBetween: 24
            }
        }
    });
}
